





















































import { Component, Vue } from 'vue-property-decorator';
import '../../assets/css/AccountSetup.scss';
import { MedTransGoConstants } from '../../util/constants';
import { Language } from '../../types/entity';
import { required } from 'vuelidate/lib/validators';
import { ObjectFactory } from '../../config/objectFactory';
import { ApiRequest, ProfileRequest } from '../../types/request';
import { CommonUtils } from '../../util/commonUtils';
import MessageBox from '../../components/MessageBox.vue';
import { ApiResponse, UploadFileResponse } from '@/types/response';
import { LoaderEvent, ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
@Component({
    components: {
        MessageBox,
    },
    props: {
        request: Object,
    },
    validations: {
        request: {
            languageCertificates: {
                required,
                $each: {
                    languageId: {
                        required,
                    },
                    certificate: {
                    },
                },
            },
        },
    },
})
export default class UploadCertificate extends Vue {

    private languages: Language[] = [];
    private isValidFile = false;
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private isFormValid = false;
    private showDeleteConfirmBox = false;
    private selectedCertificateIndex: number = 0;
    private supportedFormats = [
        'image/png',
        'image/jpeg',
        'application/pdf',
    ];
    private async setCertificate($event: any, index: number) {
        const filename: string = $event.target.files[0].name.toLowerCase();
        if (filename.endsWith('.pdf') || filename.endsWith('.png') ||
            filename.endsWith('.jpeg') || filename.endsWith('.jpg')) {
            this.getProfileRequest().languageCertificates[index].certificate = $event.target.files[0];
            this.getProfileRequest().languageCertificates[index].name = $event.target.files[0].name;
            this.validateForm();
        } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be PDF, JPEG, PNG',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            const inputName = `file-input${index}`;
            const element = this.$refs[inputName] as any;
            element[0].reset();
        }
    }

    private filterLanguages(index: any) {
        index = parseInt(index, 10);
        const selectedLanguages: string[] = [];
        this.getProfileRequest().languageCertificates.forEach((element, elementIndex) => {
            if (elementIndex !== index && element.languageId) {
                selectedLanguages.push(element.languageId);
            }
        });
        if (selectedLanguages.length) {
            return this.languages.filter((langauage) => {
                return langauage.id && !selectedLanguages.includes(langauage.id);
            });
        }
        return this.languages;
    }

    private validateForm() {
        this.getProfileRequest().languageCertificates.forEach((language) => {
            if (language.certificateId || language.certificate) {
                this.isFormValid = true;
            } else {
                this.isFormValid = false;
            }
        });
    }

    private mounted() {
        if (this.$v) {
            this.$v.$touch();
        }
        const profileRequest = this.getProfileRequest();
        profileRequest.isStepUCValid = false;
        if (this.sessionInfo.scopes.includes('interpreter') && profileRequest.isStepPIValid) {
            if (profileRequest.languages) {
                this.languages = profileRequest.languages;
            }
            this.getLanguages();
            this.validateForm();
        } else {
            this.back();
        }
    }

    private async getLanguages() {
        if (!this.languages || this.languages.length <= 0) {
            const iHttpService = ObjectFactory.getHttpService();
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_LANGUAGES}`,
                loaderEvent: {
                    show: true,
                },
            };
            const apiResponse = await iHttpService.get<Language[]>(apiRequest);
            if (apiResponse.success && apiResponse.data) {
                this.languages = apiResponse.data;
                this.getProfileRequest().languages = this.languages;
            } else {
                CommonUtils.showError(apiResponse);
            }
        }
    }

    private back() {
        if (this.sessionInfo.scopes.includes('transporter')) {
            this.$router.push({ name: MedTransGoConstants.VIEW_HEALTH_INSURANCE_INFO_NAME });
        } else {
             this.$router.push({ name: MedTransGoConstants.VIEW_PERSONAL_INFO_NAME });
        }
    }

    private getProfileRequest(): ProfileRequest {
        return this.$props.request as ProfileRequest;
    }

    private logout() {
        CommonUtils.logout(this.$store.state);
    }

    private addLanguageElement() {
        const profileRequest = this.getProfileRequest();
        profileRequest.languageCertificates.push({
            certificateId: '',
            name: '',
            languageId: '',
        });
        if (this.$v) {
            this.$v.$touch();
        }
    }

    private async deleteLanguageElement(index: number) {
        await this.removeCertificate(index);
        const profileRequest = this.getProfileRequest();
        profileRequest.languageCertificates.splice(index, 1);
        this.validateForm();
    }

    private async removeCertificate(index: number) {
        const profileRequest = this.getProfileRequest();
        const certificate = profileRequest.languageCertificates[index];
        if (certificate.certificateId) {
            const response = await ObjectFactory.getFileService().
                deleteFile(certificate.certificateId, this.$store.state.serverUrl);
            if (response.success) {
                certificate.certificateId = '';
            }
        }
        certificate.certificate = undefined;
        certificate.name = '';
        this.showDeleteConfirmBox = false;
        this.validateForm();
    }

    private async uploadCertificates() {
        const promises: Array<Promise<ApiResponse<UploadFileResponse>>> = [];
        const profileRequest: ProfileRequest = this.$props.request;
        const indexes: number[] = [];
        let index = 0;
        profileRequest.languageCertificates.forEach((certificate) => {
            if (certificate.certificate && !certificate.certificateId) {
                const formData = new FormData();
                formData.append('file', certificate.certificate as any);
                indexes.push(index);
                promises.push(ObjectFactory.getFileService()
                    .uploadFile(formData, this.$store.state.serverUrl));
            }
            index++;
        });
        if (promises.length >= 1) {
            const loaderEvent: LoaderEvent = {
                show: true,
                message: 'Uploading',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_LOADER, loaderEvent);
            Promise.all(promises).then((uploadDocumentResponses) => {
                let indexTemp = 0;
                uploadDocumentResponses.forEach((uploadDocumentResponse) => {
                    const documentIndex = indexes[indexTemp];
                    const document = profileRequest.languageCertificates[documentIndex];
                    if (uploadDocumentResponse.success && uploadDocumentResponse.data) {
                        document.certificateId = uploadDocumentResponse.data.fileName;
                    }
                    indexTemp++;
                });
            }).catch(() => {
                const toastEvent: ToastEvent = {
                    message: 'Failed to upload document',
                    title: 'Error!',
                    timeout: 5000,
                    varient: 'danger',
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            }).finally(() => {
                loaderEvent.show = false;
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_LOADER, loaderEvent);
                this.validateForm();
                if (this.isFormValid) {
                    this.savePartnerProfile();
                }
            });
        } else {
            this.savePartnerProfile();
        }
    }

    private async savePartnerProfile() {
        const profileRequest = this.getProfileRequest();
        if (profileRequest.updatePartnerProfileRequest.interpreterProfile) {
            profileRequest.updatePartnerProfileRequest.interpreterProfile.languages = [];
            profileRequest.languageCertificates.forEach((document) => {
                if (profileRequest.updatePartnerProfileRequest.interpreterProfile &&
                    profileRequest.updatePartnerProfileRequest.interpreterProfile.languages
                    && document.languageId) {
                    profileRequest.updatePartnerProfileRequest.interpreterProfile.languages.push({
                        certificates: [
                            {
                                certificateId: document.certificateId,
                                name: document.name,
                            },
                        ],
                        languageId: document.languageId,
                    });
                }
            });
        }
        const updatePartnerProfileResponse = await ObjectFactory.getPartnerService()
            .updatePartnerProfile(this.getProfileRequest().updatePartnerProfileRequest, this.$store.state.serverUrl);
        if (updatePartnerProfileResponse.success) {
            if (this.sessionInfo.scopes.includes('transporter') || this.sessionInfo.scopes.includes('homeHealthCare')) {
                this.getProfileRequest().isStepUCValid = true;
                this.$router.push({ name: MedTransGoConstants.VIEW_UPLOAD_DOCUMENTS_NAME });
            } else {
                const messageBox: any = this.$refs.messageBox;
                messageBox.showModal();
            }
        }
    }
}
